const notification = {
  success: true,
  title: '',
  content: '',
};

export default notification;
